export default __webpack_public_path__ + "static/media/Poshmark_logo.02e065fb.png";